var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-block"},[_c('v-img',{staticClass:"error-block__icon",attrs:{"alt":"Alert icon","src":_vm.images.Alert}}),_c('span',{staticClass:"error-block__title"},[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }